import { formatCurrency } from '@crm/shared';
import { Card, CardContent, CardHeader, CardTitle, Spinner } from '@crm/ui';
import { useCashbackCustomer } from '../api';

/**
 * Resumo do cliente na ficha dele: quanto ja comprou e como esta o cashback.
 * Saldo ativo e o que ele pode usar hoje; o vencido fica a vista para o
 * atendente ter o que dizer quando o cliente perguntar.
 */
export function CustomerCashbackCard({ customerId }: { customerId: string }) {
  const summary = useCashbackCustomer(customerId);

  const rows = [
    { label: 'Total comprado', value: summary.data?.totalSpent ?? 0, tone: '' },
    { label: 'Cashback ganho', value: summary.data?.earned ?? 0, tone: '' },
    { label: 'Cashback usado', value: summary.data?.used ?? 0, tone: 'text-muted-foreground' },
    { label: 'Saldo a usar', value: summary.data?.active ?? 0, tone: 'text-emerald-600' },
    { label: 'Saldo expirado', value: summary.data?.expired ?? 0, tone: 'text-muted-foreground' },
  ];

  return (
    <Card variant="flush" className="mx-auto max-w-2xl">
      <CardHeader>
        <CardTitle className="text-base">Cashback e compras</CardTitle>
      </CardHeader>
      <CardContent>
        {summary.isLoading ? (
          <div className="flex justify-center py-6">
            <Spinner className="h-5 w-5 text-muted-foreground" />
          </div>
        ) : (
          <dl className="grid grid-cols-2 gap-4 sm:grid-cols-3">
            {rows.map((row) => (
              <div key={row.label}>
                <dt className="text-xs text-muted-foreground">{row.label}</dt>
                <dd className={`mt-1 text-lg font-semibold tabular-nums ${row.tone}`}>
                  {formatCurrency(row.value)}
                </dd>
              </div>
            ))}
          </dl>
        )}
      </CardContent>
    </Card>
  );
}
